import { API } from '~apis/axios/instance';
import { Mapping } from '~components/Transactions/MappingModal/constant';
import { ResponseBaseWithData } from '~types/response';

export const patchLabellingBulk = ({
  companyId,
  mappings,
}: {
  companyId: string;
  mappings: Mapping[];
}) => {
  return API.patch<ResponseBaseWithData>(`/api/v2/companies/${companyId}/labeling/bulk`, {
    data: {
      labelingItems: mappings.map((mapping) => ({
        accountId: mapping.accountId,
        labelId: mapping.labelId,
        transactionId: mapping.transactionId,
        categoryId: mapping.category.categoryId,
        customLabelId: !mapping?.customLabelId ? null : mapping.customLabelId,
        businessEntityId: !mapping?.businessEntityId ? null : mapping.businessEntityId,
        companySpecificCategoryId: mapping?.companySpecificCategoryId ?? null,
        invoiceMapping:
          (mapping.taxInvoices?.length ?? 0) > 0 || mapping.ignoreDiffReason
            ? {
                items: mapping.taxInvoices?.map((taxInvoice) => ({
                  invoiceId: taxInvoice.id,
                  invoiceType: taxInvoice.type,
                })),
                extraMapping:
                  mapping.ignoreDiffReason || mapping.memo
                    ? {
                        type: mapping.ignoreDiffReason,
                        memo: mapping.memo,
                      }
                    : undefined,
              }
            : undefined,
      })),
    },
  });
};
